import { Dialog, DialogProps, Theme } from '@mui/material';

export const StyledDialog = ({ children, ...props }: DialogProps) => (
  <Dialog
    {...props}
    slotProps={{
      paper: {
        sx: {
          backgroundColor: 'transparent',
          bottom: (theme: Theme) => theme.spacing(6),
          boxShadow: 'none',
          position: 'fixed',
          right: (theme: Theme) => theme.spacing(2),
          zIndex: 3,
        },
      },
    }}
  >
    {children}
  </Dialog>
);
